export interface SelectCategories {
  id: number;
  description: string;
}

export interface EcommerceFilterOption {
  id?: number | null;
  label: string;
  value?: string | null;
  count: number;
}

export interface EcommerceAttributeFilterGroup {
  productAttributeDefinitionId: number;
  name: string;
  values: EcommerceFilterOption[];
}

export interface EcommerceProductFilters {
  brands: EcommerceFilterOption[];
  attributes: EcommerceAttributeFilterGroup[];
}
